<div class="rd-widget rd-widget-no-height-restriction widget-{{widgetConfig.widgetId}}" *ngIf="widgetData">

  <table data-id="widgetEsg" class="widgetEsg widget-large widgetNoTopBorder cellspacing-0 cellpadding-0" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-large">
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-space">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th scope="col" colspan="33" class="widget-title-esg widgetNoTopBorderShowCell widget-title-backgroundred" style="text-align:left;">{{'esg.labelEsg' | rdTranslate}}</th>
      </tr>
      <tr>
        <td colspan="33" class="widget-text-value widget-h1 widget-align-right">&nbsp;</td>
      </tr>
      <tr>
        <th scope="col" colspan="33" class="widget-title-esg widgetNoTopBorderShowCell widget-title-backgroundred" style="text-align:left;">{{'esg.labelFundamentals' | rdTranslate}}</th>
      </tr>
      <tr>
        <td colspan="33" class="widget-text-value widget-h1 widget-align-left">
          <div class="widget-div-justified-text widget-h1 widget-text" style="overflow: hidden; margin:-1px 0 0 0;line-height:22px; word-wrap:break-word; height:190px;">{{'esg.labelFundamentalsText' | rdTranslate}}</div>
        </td>
      </tr>
      <tr>
        <th scope="col" colspan="33" class="widget-title-esg widgetNoTopBorderShowCell widget-title-backgroundred" style="text-align:left;">{{'esg.labelGeneralSustainabilityCriteria' | rdTranslate}}</th>
      </tr>
      <tr>
        <th scope="col" colspan="33" class="widget-title-esg widgetNoTopBorderShowCell light-grey-line-padding darkGreyTableHeader" style="text-align:left;">{{'esg.labelALocation' | rdTranslate}}</th>
      </tr>
      <tr class="color-light-grey-widget-line">
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.mobilityAccessibility' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.mobilityAccessibility | rdReflist: reflists['ref_esg_location']}}</td>
        <td *ngIf="editMode" colspan="6">
          <kendo-dropdownlist [data]="reflists['ref_esg_location']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.mobilityAccessibility"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr>
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.localSupply' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.localSupply | rdReflist: reflists['ref_esg_location']}}</td>
        <td *ngIf="editMode" colspan="6">
          <kendo-dropdownlist [data]="reflists['ref_esg_location']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.localSupply"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr class="color-light-grey-widget-line">
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.socialInfrastructure' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.socialInfrastructure | rdReflist: reflists['ref_esg_location']}}</td>
        <td *ngIf="editMode" colspan="6">
          <kendo-dropdownlist [data]="reflists['ref_esg_location']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.socialInfrastructure"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr>
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.qualityOfSurrounding' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.qualityOfSurrounding | rdReflist: reflists['ref_esg_location']}}</td>
        <td *ngIf="editMode" colspan="6">
          <kendo-dropdownlist [data]="reflists['ref_esg_location']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.qualityOfSurrounding"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr>
        <td colspan="33" class="widget-text-value widget-h1 widget-align-right">&nbsp;</td>
      </tr>
      <tr>
        <th scope="col" colspan="33" class="widget-title-esg widgetNoTopBorderShowCell light-grey-line-padding darkGreyTableHeader" style="text-align:left;">{{'esg.labelBProperty' | rdTranslate}}</th>
      </tr>
      <tr class="color-light-grey-widget-line">
        <td colspan="18" class="widget-h1 widget-lable-left">{{'esg.mainEnergySource' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="15" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.mainEnergySource | rdReflist: reflists['ref_esg_energy_source']}}</td>
        <td *ngIf="editMode" colspan="15" class="noBorderTop">
          <kendo-dropdownlist [data]="reflists['ref_esg_energy_source']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.mainEnergySource"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr>
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.airConditioningCooling' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.airConditioningCooling | rdReflist: reflists['ref_esg_yes_no_partly_na']}}</td>
        <td *ngIf="editMode" colspan="6">
          <kendo-dropdownlist [data]="reflists['ref_esg_yes_no_partly_na']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.airConditioningCooling"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr class="color-light-grey-widget-line">
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.useOfRenewableEnergies' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.useOfRenewableEnergies | rdReflist: reflists['ref_esg_yes_no_na']}}</td>
        <td *ngIf="editMode" colspan="6">
          <kendo-dropdownlist [data]="reflists['ref_esg_yes_no_na']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.useOfRenewableEnergies"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr>
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.refurbishmentMeasuresToImproveEnergyEfficiencyBuildingShell' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.refurbishmentMeasuresToImproveEnergyEfficiencyBuildingShell | rdReflist: reflists['ref_esg_completeness']}}</td>
        <td *ngIf="editMode" colspan="6">
          <kendo-dropdownlist [data]="reflists['ref_esg_completeness']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.refurbishmentMeasuresToImproveEnergyEfficiencyBuildingShell"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr class="color-light-grey-widget-line">
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.refurbishmentMeasuresToImproveEnergyEfficiencyBuildingServicesEquipment' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.refurbishmentMeasuresToImproveEnergyEfficiencyBuildingServicesEquipment | rdReflist: reflists['ref_esg_completeness']}}</td>
        <td *ngIf="editMode" colspan="6">
          <kendo-dropdownlist [data]="reflists['ref_esg_completeness']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.refurbishmentMeasuresToImproveEnergyEfficiencyBuildingServicesEquipment"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr>
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.electricCarChargingStationsAvailableOnSite' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.electricCarChargingStationsAvailableOnSite | rdReflist: reflists['ref_esg_availability']}}</td>
        <td *ngIf="editMode" colspan="6">
          <kendo-dropdownlist [data]="reflists['ref_esg_availability']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.electricCarChargingStationsAvailableOnSite"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr class="color-light-grey-widget-line">
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.carsharing' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.carsharing | rdReflist: reflists['ref_esg_availability']}}</td>
        <td *ngIf="editMode" colspan="6">
          <kendo-dropdownlist [data]="reflists['ref_esg_availability']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.carsharing"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr>
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.bicycleParkingAvailableOnSite' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.bicycleParkingAvailableOnSite | rdReflist: reflists['ref_esg_availability']}}</td>
        <td *ngIf="editMode" colspan="6">
          <kendo-dropdownlist [data]="reflists['ref_esg_availability']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.bicycleParkingAvailableOnSite"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr class="color-light-grey-widget-line">
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.barrierFreeAccess' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.barrierFreeAccess | rdReflist: reflists['ref_esg_completeness2']}}</td>
        <td *ngIf="editMode" colspan="6">
          <kendo-dropdownlist [data]="reflists['ref_esg_completeness2']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.barrierFreeAccess"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr>
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.roofFacadeGreening' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.roofFacadeGreening | rdReflist: reflists['ref_esg_availability']}}</td>
        <td *ngIf="editMode" colspan="6">
          <kendo-dropdownlist [data]="reflists['ref_esg_availability']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.roofFacadeGreening"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr class="color-light-grey-widget-line" *ngIf="currentLayout === 'Residential'">
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.communityAndSocialAreas' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.communityAndSocialAreas  | rdReflist: reflists['ref_esg_availability']}}</td>
        <td *ngIf="editMode" colspan="6">
          <kendo-dropdownlist [data]="reflists['ref_esg_availability']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.communityAndSocialAreas"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr>
        <td colspan="33" class="widget-text-value widget-h1 widget-align-right">&nbsp;</td>
      </tr>
      <tr>
        <th scope="col" colspan="33" class="widget-title-esg widgetNoTopBorderShowCell light-grey-line-padding darkGreyTableHeader" style="text-align:left;">{{'esg.labelCTenant' | rdTranslate}}</th>
      </tr>
      <tr>
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.mainTenant' | rdTranslate}}</td>
          <td colspan="6">
          <input type="text" [(ngModel)]="widgetData.mainTenant"   
          hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
          [elType]="'text'" [page]="page"  
          [editMode]="editMode" 
          (setNewValue)="widgetData.mainTenant= $event;"  [disabled]="!editMode"
          id="mainTenant" class="widget-input-text widget-h1 field-text-align-end gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
        </td>
      </tr>
      <tr class="color-light-grey-widget-line">
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.businessSector' | rdTranslate}}</td>
        <td colspan="6">
          <input type="text"
                 hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
                 [elType]="'text'" [page]="page"
                 [editMode]="editMode"
                 (setNewValue)="widgetData.businessSector= $event;" [disabled]="!editMode"
                 id="businessSector" [(ngModel)]="widgetData.businessSector" class="widget-input-text widget-h1 field-text-align-end gridster-item-content" (ngModelChange)="setDirtyFlag(true)" />
        </td>
      </tr>
      <tr>
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.potentialSectorRisk' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.potentialSectorRisk | rdReflist: reflists['ref_esg_yes_no_na']}}</td>
        <td *ngIf="editMode" colspan="6">
          <kendo-dropdownlist [data]="reflists['ref_esg_yes_no_na']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.potentialSectorRisk"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr class="color-light-grey-widget-line">
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.badNegativePress' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.badNegativePress | rdReflist: reflists['ref_esg_yes_no_na']}}</td>
        <td *ngIf="editMode" colspan="6">
          <kendo-dropdownlist [data]="reflists['ref_esg_yes_no_na']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.badNegativePress"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr *ngIf="currentLayout === 'Residential'">
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.rentControl' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.rentControl | rdReflist: reflists['ref_esg_availability']}}</td>
        <td *ngIf="editMode" colspan="6">
          <kendo-dropdownlist [data]="reflists['ref_esg_availability']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.rentControl"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr class="color-light-grey-widget-line" *ngIf="currentLayout === 'Residential'">
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.occupancyObligation' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.occupancyObligation | rdReflist: reflists['ref_esg_availability']}}</td>
        <td *ngIf="editMode" colspan="6">
          <kendo-dropdownlist [data]="reflists['ref_esg_availability']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.occupancyObligation"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr *ngIf="currentLayout === 'Residential'">
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.shareOfSocialHousingInPercent' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.shareOfSocialHousingInPercent | rdLocalizedNumber:0 }}%</td>
        <td *ngIf="editMode" colspan="6">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.shareOfSocialHousingInPercent" [isNullable]="true" [decimals]="0" [thousandsSeparators]="true" (valueChange)="setDirtyFlag(true)"></pollux-report-designer-numeric-field>
        </td>
      </tr>
      <tr>
        <td colspan="33" class="widget-text-value widget-h1 widget-align-right">&nbsp;</td>
      </tr>
      <tr>
        <th scope="col" colspan="24" class="widget-title-esg widgetNoTopBorderShowCell widget-title-backgroundred" style="text-align:left;">{{'esg.labelEnergyPerformanceCertificate' | rdTranslate}}</th>
        <th scope="col" colspan="3" class="widget-title-esg widgetNoTopBorderShowCell widget-title-backgroundred" style="text-align:left;">{{'esg.labelAvailable' | rdTranslate}}</th>
        <th scope="col" colspan="6" class="widget-title-esg widgetNoTopBorderShowCell widget-title-backgroundred" style="text-align:left;" *ngIf="!editMode">
          {{ widgetData.energyPerformanceCertificateAvailable | rdReflist: reflists['ref_esg_yes_no']}}
        </th>
        <th scope="col" colspan="6" class="widget-title-esg widgetNoTopBorderShowCell widget-title-backgroundred" style="text-align:left;" *ngIf="editMode">
          <kendo-dropdownlist [data]="reflists['ref_esg_yes_no']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.energyPerformanceCertificateAvailable"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </th>
      </tr>
      <tr class="color-light-grey-widget-line" *ngIf="widgetData && widgetData.energyPerformanceCertificateAvailable != 2">
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.typeOfEnergyPerformanceCertificate' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.typeOfEnergyPerformanceCertificate | rdReflist: reflists['ref_esg_energy_performance_certificate']}}</td>
        <td *ngIf="editMode" colspan="6">
          <kendo-dropdownlist [data]="reflists['ref_esg_energy_performance_certificate']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.typeOfEnergyPerformanceCertificate"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr *ngIf="widgetData && widgetData.energyPerformanceCertificateAvailable != 2">
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.energyPerformanceCertificateValidUntil' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.energyPerformanceCertificateValidUntil | rdLocalizedDate}}</td>
        <td *ngIf="editMode" colspan="6">
          <pollux-report-designer-date-field ngDefaultControl [(ngModel)]="widgetData.energyPerformanceCertificateValidUntil" (ngChange)="setDirtyFlag(true)" [isNullable]="true" ng-id="form-energyPerformanceCertificateValidUntil"></pollux-report-designer-date-field>
        </td>
      </tr>
      <tr *ngIf="widgetData && widgetData.energyPerformanceCertificateAvailable != 2 && widgetData.typeOfEnergyPerformanceCertificate != 1">
        <td colspan="33" class="widget-text-value widget-h1 widget-align-right">&nbsp;</td>
      </tr>
      <tr *ngIf="widgetData && widgetData.energyPerformanceCertificateAvailable != 2 && widgetData.typeOfEnergyPerformanceCertificate != 1">
        <th scope="col" colspan="33" class="widget-title-esg widgetNoTopBorderShowCell light-grey-line-padding darkGreyTableHeader" style="text-align:left;">{{'esg.labelConsumptionCertificate' | rdTranslate}}</th>
      </tr>

      <tr class="color-light-grey-widget-line" *ngIf="!editMode && widgetData && widgetData.energyPerformanceCertificateAvailable != 2 && widgetData.typeOfEnergyPerformanceCertificate != 1">
        <td colspan="12" class="widget-h1 widget-align-left">{{'esg.heatHotWater' | rdTranslate}}</td>
        <td colspan="15" class="widget-h1 widget-align-left" style="padding-right: 2px;">
          <div class="slider-container" [class.noValue]="widgetData.maxValueOfTheChartHeatHotWater === null">
            <kendo-slider [(ngModel)]="heatHotWaterPercent"
                          [vertical]="false"
                          [showButtons]="false"
                          [min]="0"
                          [max]="100"
                          [animate]="!rdStorage.getAppPrintMode()">
            </kendo-slider>
          </div>
        </td>
        <td colspan="6" class="widget-text-value widget-h1 widget-align-right">
          {{ widgetData.heatHotWater | rdLocalizedNumber:2}} <span>{{'esg.labelKwh' | rdTranslate:translateReplacements}}</span>
        </td>
      </tr>
      <tr class="color-light-grey-widget-line" *ngIf="editMode && widgetData && widgetData.energyPerformanceCertificateAvailable != 2 && widgetData.typeOfEnergyPerformanceCertificate != 1">
        <td colspan="6" class="widget-h1 widget-align-left">{{'esg.heatHotWater' | rdTranslate}}</td>
        <td colspan="10" class="widget-h1 widget-align-left">
          <div class="slider-container" [class.noValue]="widgetData.maxValueOfTheChartHeatHotWater === null">
            <kendo-slider [(ngModel)]="heatHotWaterPercent"
                          [vertical]="false"
                          [showButtons]="false"
                          [min]="0"
                          [max]="100"
                          [animate]="!rdStorage.getAppPrintMode()">
            </kendo-slider>
          </div>
        </td>
        <td colspan="6" class="widget-h1 widget-align-left paddingLeft10">{{'esg.labelMaxValueOfTheChart' | rdTranslate}}</td>
        <td colspan="5" style="padding-right: 2px;">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.maxValueOfTheChartHeatHotWater" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true" (valueChange)="maxValueHeatHotWaterChanged(true)"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="3">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.heatHotWater" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true" (valueChange)="maxValueHeatHotWaterChanged(true)"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="3" class="widget-text-value widget-h1 widget-align-right">
          <span>{{'esg.labelKwh' | rdTranslate:translateReplacements}}</span>
        </td>
      </tr>
      <tr *ngIf="!editMode && widgetData && widgetData.energyPerformanceCertificateAvailable != 2 && widgetData.typeOfEnergyPerformanceCertificate != 1">
        <td colspan="12" class="widget-h1 widget-align-left">{{'esg.electricity' | rdTranslate}}</td>
        <td colspan="15" class="widget-h1 widget-align-left">
          <div class="slider-container" [class.noValue]="widgetData.maxValueOfTheChartElectricity === null">
            <kendo-slider [(ngModel)]="electricityPercent"
                          [vertical]="false"
                          [showButtons]="false"
                          [min]="0"
                          [max]="100">
            </kendo-slider>
          </div>
        </td>

        <td colspan="6" class="widget-text-value widget-h1 widget-align-right">
          {{ widgetData.electricity | rdLocalizedNumber:2}} <span>{{'esg.labelKwh' | rdTranslate:translateReplacements}}</span>
        </td>
      </tr>
      <tr *ngIf="editMode && widgetData && widgetData.energyPerformanceCertificateAvailable != 2 && widgetData.typeOfEnergyPerformanceCertificate != 1">
        <td colspan="6" class="widget-h1 widget-align-left">{{'esg.electricity' | rdTranslate}}</td>
        <td colspan="10" class="widget-h1 widget-align-left">
          <div class="slider-container" [class.noValue]="widgetData.maxValueOfTheChartElectricity === null">
            <kendo-slider [(ngModel)]="electricityPercent"
                          [vertical]="false"
                          [showButtons]="false"
                          [min]="0"
                          [max]="100">
            </kendo-slider>
          </div>
        </td>
        <td colspan="6" class="widget-h1 widget-align-left paddingLeft10">{{'esg.labelMaxValueOfTheChart' | rdTranslate}}</td>
        <td colspan="5" style="padding-right: 2px;">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.maxValueOfTheChartElectricity" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true" (valueChange)="maxValueElectricityChanged(true)"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="3">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.electricity" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true" (valueChange)="maxValueElectricityChanged(true)"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="3" class="widget-text-value widget-h1 widget-align-right">
          <span>{{'esg.labelKwh' | rdTranslate:translateReplacements}}</span>
        </td>
      </tr>
      <tr *ngIf="widgetData && widgetData.energyPerformanceCertificateAvailable != 2 && widgetData.typeOfEnergyPerformanceCertificate != 1">
        <td colspan="27" class="widget-text-total widget-h1 widget-bold widget-align-left">{{'esg.labelFinalEnergyTotal' | rdTranslate}}</td>

        <td colspan="3" class="widget-text-total  widget-text-value widget-h1 widget-align-left" *ngIf="editMode" style="padding-left: 15px;">
          {{ widgetData.finalEnergyTotal | rdLocalizedNumber:2}}
        </td>
        <td colspan="3" class="widget-text-total widget-text-value widget-bold widget-h1 widget-align-right" *ngIf="editMode">
          <span>{{'esg.labelKwh' | rdTranslate:translateReplacements}}</span>
        </td>
        <td colspan="6" class="widget-text-total widget-h1 widget-bold widget-align-right" *ngIf="!editMode">
          {{ widgetData.finalEnergyTotal | rdLocalizedNumber:2}} <span>{{'esg.labelKwh' | rdTranslate:translateReplacements}}</span>
        </td>
      </tr>
      <tr *ngIf="editMode &&  widgetData && widgetData.energyPerformanceCertificateAvailable != 2 && widgetData.typeOfEnergyPerformanceCertificate != 1">
        <td colspan="27" class="widget-h1 widget-align-left">{{'esg.labelPrimaryEnergy' | rdTranslate}}</td>

        <td colspan="3">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.consumptionCertificatePrimaryEnergy" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true" (valueChange)="setDirtyFlag(true)"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="3" class="widget-text-value widget-h1 widget-align-right">
          <span>{{'esg.labelKwh' | rdTranslate:translateReplacements}}</span>
        </td>
      </tr>
      <tr *ngIf="!editMode && widgetData && widgetData.energyPerformanceCertificateAvailable != 2 && widgetData.typeOfEnergyPerformanceCertificate != 1">
        <td colspan="27" class="widget-h1 widget-align-left">{{'esg.labelPrimaryEnergy' | rdTranslate}}</td>

        <td colspan="6" class="widget-text-value widget-h1 widget-align-right">
          {{ widgetData.consumptionCertificatePrimaryEnergy | rdLocalizedNumber:2}} <span>{{'esg.labelKwh' | rdTranslate:translateReplacements}}</span>
        </td>
      </tr>
      <tr class="color-light-grey-widget-line" *ngIf="editMode && widgetData && widgetData.energyPerformanceCertificateAvailable != 2 && widgetData.typeOfEnergyPerformanceCertificate != 1">
        <td colspan="27" class="widget-h1 widget-align-left">{{'esg.labelCo2Emission' | rdTranslate:translateReplacements}}</td>
        <td colspan="3">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.consumptionCertificateCo2Emission" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true" (valueChange)="setDirtyFlag(true)"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="3" class="widget-text-value widget-h1 widget-align-right">
          <span>{{'esg.labelKg' | rdTranslate:translateReplacements}}</span>
        </td>
      </tr>
      <tr class="color-light-grey-widget-line" *ngIf="!editMode && widgetData && widgetData.energyPerformanceCertificateAvailable != 2 && widgetData.typeOfEnergyPerformanceCertificate != 1">
        <td colspan="27" class="widget-h1 widget-align-left">{{'esg.labelCo2Emission' | rdTranslate:translateReplacements}}</td>
        <td colspan="6" class="widget-text-value widget-h1 widget-align-right">
          {{ widgetData.consumptionCertificateCo2Emission | rdLocalizedNumber:2}} <span>{{'esg.labelKg' | rdTranslate:translateReplacements}}</span>
        </td>
      </tr>
      <tr *ngIf="widgetData && widgetData.energyPerformanceCertificateAvailable != 2 && widgetData.typeOfEnergyPerformanceCertificate != 2">
        <td colspan="33" class="widget-text-value widget-h1 widget-align-right">&nbsp;</td>
      </tr>
      <tr *ngIf="widgetData && widgetData.energyPerformanceCertificateAvailable != 2 && widgetData.typeOfEnergyPerformanceCertificate != 2">
        <th scope="col" colspan="33" class="widget-title-esg widgetNoTopBorderShowCell light-grey-line-padding darkGreyTableHeader" style="text-align:left;">{{'esg.labelDemandCertificate' | rdTranslate}}</th>
      </tr>

      <tr *ngIf="editMode && widgetData && widgetData.energyPerformanceCertificateAvailable != 2 && widgetData.typeOfEnergyPerformanceCertificate != 2">
        <td colspan="27" class="widget-text-total widget-h1 widget-bold widget-align-left">{{'esg.labelFinalEnergyTotal' | rdTranslate}}</td>
        <td colspan="3" class="widget-text-total widget-h1 widget-bold widget-align-left">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.demandCertificatefinalEnergyTotal" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true" (valueChange)="setDirtyFlag(true)"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="3" class="widget-text-total widget-h1 widget-bold widget-align-right">
          <span>{{'esg.labelKwh' | rdTranslate:translateReplacements}}</span>
        </td>
      </tr>
      <tr *ngIf="!editMode && widgetData && widgetData.energyPerformanceCertificateAvailable != 2 && widgetData.typeOfEnergyPerformanceCertificate != 2">
        <td colspan="27" class="widget-text-total widget-h1 widget-bold widget-align-left">{{'esg.labelFinalEnergyTotal' | rdTranslate}}</td>
        <td colspan="6" class="widget-text-total widget-h1 widget-bold widget-align-right">
          {{ widgetData.demandCertificatefinalEnergyTotal | rdLocalizedNumber:2}} <span>{{'esg.labelKwh' | rdTranslate:translateReplacements}}</span>
        </td>
      </tr>
      <tr *ngIf="!editMode && widgetData && widgetData.energyPerformanceCertificateAvailable != 2 && widgetData.typeOfEnergyPerformanceCertificate != 2">
        <td colspan="12" class="widget-h1 widget-align-left">{{'esg.labelPrimaryEnergy' | rdTranslate}}</td>
        <td colspan="15" class="widget-h1 widget-align-left">
          <div class="slider-container" [class.noValue]="widgetData.maxValueOfTheChartDemandCertificatePrimaryEnergy === null">
            <kendo-slider [(ngModel)]="demandCertificatePrimaryEnergyPercent"
                          [vertical]="false"
                          [showButtons]="false"
                          [min]="0"
                          [max]="100">
            </kendo-slider>
          </div>
        </td>
        <td colspan="6" class="widget-text-value widget-h1 widget-align-right">
          {{ widgetData.demandCertificatePrimaryEnergy | rdLocalizedNumber:2}} <span>{{'esg.labelKwh' | rdTranslate:translateReplacements}}</span>
        </td>
      </tr>
      <tr *ngIf="editMode && widgetData && widgetData.energyPerformanceCertificateAvailable != 2 && widgetData.typeOfEnergyPerformanceCertificate != 2">
        <td colspan="6" class="widget-h1 widget-align-left">{{'esg.labelPrimaryEnergy' | rdTranslate}}</td>
        <td colspan="10" class="widget-h1 widget-align-left">
          <div class="slider-container" [class.noValue]="widgetData.maxValueOfTheChartDemandCertificatePrimaryEnergy === null">
            <kendo-slider [(ngModel)]="demandCertificatePrimaryEnergyPercent"
                          [vertical]="false"
                          [showButtons]="false"
                          [min]="0"
                          [max]="100">
            </kendo-slider>
          </div>
        </td>
        <td colspan="6" class="widget-h1 widget-align-left paddingLeft10">{{'esg.labelMaxValueOfTheChart' | rdTranslate}}</td>
        <td colspan="5" style="padding-right: 2px;">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.maxValueOfTheChartDemandCertificatePrimaryEnergy" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true" (valueChange)="maxValueDemandCertificatePrimaryEnergyChanged(true)"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="3">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.demandCertificatePrimaryEnergy" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true" (valueChange)="maxValueDemandCertificatePrimaryEnergyChanged(true)"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="3" class="widget-text-value widget-h1 widget-align-right">
          <span>{{'esg.labelKwh' | rdTranslate:translateReplacements}}</span>
        </td>
      </tr>
      <tr class="color-light-grey-widget-line" *ngIf="editMode && widgetData && widgetData.energyPerformanceCertificateAvailable != 2 && widgetData.typeOfEnergyPerformanceCertificate != 2">
        <td colspan="27" class="widget-h1 widget-align-left">{{'esg.labelCo2Emission' | rdTranslate:translateReplacements}}</td>
        <td colspan="3">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.demandCertificateCo2Emission" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true" (valueChange)="setDirtyFlag(true)"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="3" class="widget-text-value widget-h1 widget-align-right">
          <span>{{'esg.labelKg' | rdTranslate:translateReplacements}}</span>
        </td>
      </tr>
      <tr class="color-light-grey-widget-line" *ngIf="!editMode && widgetData && widgetData.energyPerformanceCertificateAvailable != 2 && widgetData.typeOfEnergyPerformanceCertificate != 2">
        <td colspan="27" class="widget-h1 widget-align-left">{{'esg.labelCo2Emission' | rdTranslate:translateReplacements}}</td>
        <td colspan="6" class="widget-text-value widget-h1 widget-align-right">
          {{ widgetData.demandCertificateCo2Emission | rdLocalizedNumber:2}} <span>{{'esg.labelKg' | rdTranslate:translateReplacements}}</span>
        </td>
      </tr>
      <tr>
        <td colspan="33" class="widget-text-value widget-h1 widget-align-right">&nbsp;</td>
      </tr>
      <tr>
        <th scope="col" colspan="24" class="widget-title-esg widgetNoTopBorderShowCell widget-title-backgroundred" style="text-align:left;">{{'esg.labelGreenBuildingCertificate' | rdTranslate}}</th>
        <th scope="col" colspan="3" class="widget-title-esg widgetNoTopBorderShowCell widget-title-backgroundred" style="text-align:left;">{{'esg.labelAvailable' | rdTranslate}}</th>
        <th scope="col" colspan="6" class="widget-title-esg widgetNoTopBorderShowCell widget-title-backgroundred" style="text-align:left;" *ngIf="!editMode">
          {{ widgetData.greenBuildingCertificateAvailable | rdReflist: reflists['ref_esg_yes_no']}}
        </th>
        <th scope="col" colspan="6" class="widget-title-esg widgetNoTopBorderShowCell widget-title-backgroundred" style="text-align:left;" *ngIf="editMode">
          <kendo-dropdownlist [data]="reflists['ref_esg_yes_no']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.greenBuildingCertificateAvailable"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </th>
      </tr>
      <tr class="color-light-grey-widget-line" *ngIf="widgetData && widgetData.greenBuildingCertificateAvailable != 2">
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.typeOfGreenBuildingCertificate' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.typeOfGreenBuildingCertificate | rdReflist: reflists['ref_esg_green_building_certificate']}}</td>
        <td *ngIf="editMode" colspan="6">
          <kendo-dropdownlist [data]="reflists['ref_esg_green_building_certificate']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.typeOfGreenBuildingCertificate"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr *ngIf="widgetData && widgetData.greenBuildingCertificateAvailable != 2">
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.furtherGreenBuildingCertificates' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.furtherGreenBuildingCertificates | rdReflist: reflists['ref_esg_green_building_certificate']}}</td>
        <td *ngIf="editMode" colspan="6">
          <kendo-dropdownlist [data]="reflists['ref_esg_green_building_certificate']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.furtherGreenBuildingCertificates"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr class="color-light-grey-widget-line" *ngIf="widgetData && widgetData.greenBuildingCertificateAvailable != 2">
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.status' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.status | rdReflist: reflists['ref_esg_status']}}</td>
        <td *ngIf="editMode" colspan="6">
          <kendo-dropdownlist [data]="reflists['ref_esg_status']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.status"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr *ngIf="widgetData && widgetData.greenBuildingCertificateAvailable != 2">
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.greenBuildingCertificateValidFrom' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.greenBuildingCertificateValidFrom | rdLocalizedDate}}</td>
        <td *ngIf="editMode" colspan="6">
          <pollux-report-designer-date-field ngDefaultControl [(ngModel)]="widgetData.greenBuildingCertificateValidFrom" (ngChange)="setDirtyFlag(true)" [isNullable]="true" ng-id="form-greenBuildingCertificateValidFrom"></pollux-report-designer-date-field>
        </td>
      </tr>
      <tr class="color-light-grey-widget-line" *ngIf="widgetData && widgetData.greenBuildingCertificateAvailable != 2">
        <td colspan="27" class="widget-h1 widget-lable-left">{{'esg.greenBuildingCertificateValidUntil' | rdTranslate}}</td>
        <td *ngIf="!editMode" colspan="6" class="widget-text-value widget-h1 widget-align-right">{{ widgetData.greenBuildingCertificateValidUntil | rdLocalizedDate}}</td>
        <td *ngIf="editMode" colspan="6">
          <pollux-report-designer-date-field ngDefaultControl [(ngModel)]="widgetData.greenBuildingCertificateValidUntil" (ngChange)="setDirtyFlag(true)" [isNullable]="true" ng-id="form-greenBuildingCertificateValidUntil"></pollux-report-designer-date-field>
        </td>
      </tr>
      <tr>
        <td colspan="33" class="widget-text-value widget-h1 widget-align-right">&nbsp;</td>
      </tr>
      <tr>
        <th scope="col" colspan="33" class="widget-title-esg widgetNoTopBorderShowCell widget-title-backgroundred" style="text-align:left;">{{'esg.labelStatement' | rdTranslate}}</th>
      </tr>
      <tr>
        <td colspan="33" class="widget-text-value widget-h1 widget-align-left">
          <div class="widget-div-justified-text widget-h1 widget-text" style="overflow: hidden; margin:-1px 0 0 0;line-height:22px; word-wrap:break-word; height:250px;">{{'esg.labelStatementText' | rdTranslate}}</div>
        </td>
      </tr>
    </tbody>
  </table>

</div>
